import {API_URL, DIST_ID, DIST_BUILD} from '@/constants/app.constant'
import {UAParser} from 'ua-parser-js'
import {getSessionId} from '@/features/context/SessionContext'

const parser = new UAParser()

export async function login({step = 0, mobileNumber, nationalCode, code, name, role, password, forgot = false}) {
    let device_vendor = parser.getDevice()?.vendor
    let device_model = parser.getDevice()?.model
    let browser = parser.getBrowser().name
    let os = parser.getOS().name
    let os_version = parser.getOS().version

    const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            step,
            mobileNumber,
            nationalCode,
            code,
            role,
            name,
            password,
            forgot,
            device_vendor,
            device_model,
            browser,
            os,
            os_version,
            app: DIST_ID,
            app_version: DIST_BUILD
        })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json()

    if (typeof data.success != 'undefined' && !data.success)
        throw new Error(data.message || 'خطای غیر منتظره‌ای رخ داده!')

    return data
}

export async function switchRole({role}) {
    const response = await fetch(`${API_URL}/auth/switch`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`
        },
        body: JSON.stringify({
            role
        })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json()

    if (typeof data.success != 'undefined' && !data.success)
        throw new Error(data.message || 'خطای غیر منتظره‌ای رخ داده!')

    return data
}

export async function logout() {
    const response = await fetch(`${API_URL}/auth/logout`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`
        },
        body: JSON.stringify()
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json()

    if (typeof data.success != 'undefined' && !data.success)
        throw new Error(data.message || 'خطای غیر منتظره‌ای رخ داده!')

    return data
}

